import $ from "jquery";
import { testDynData, getDynDataOne, createGuid } from "#scripts/general_functions";
import { mapSinglepoi } from "#scripts/map";
import language from "#scripts/translation";
import { getImageByContentId } from "#scripts/images";

export const getContactByEmail = (email, callback) => {
	if (window.serverdata.configMeta.aim.contactApi) {
		$.get(`${window.serverdata.configMeta.aim.contactApi}/${email}`).done((data) => {
			callback(data);
		});
	}
};

export const setContactRight = (model) => {
	let phone = "";
	let email = "";
	let name = "";
	let address = "";
	let title = "";
	let about = "";
	const phones = [];
	if (model.phone) {
		phones.push(
			model.phone
				.split("/")
				.map((x) => {
					return `<a href="tel:${x.trim()}">${x.trim()}</a>`;
				})
				.join("&nbsp;/&nbsp;"),
		);
	}
	if (model.wiredPhone) {
		phones.push(
			model.wiredPhone
				.split("/")
				.map((x) => {
					return `<a href="tel:${x.trim()}">${x.trim()}</a>`;
				})
				.join("&nbsp;/&nbsp;"),
		);
	}

	if (model.phone || model.wiredPhone) {
		phone = `<div class="contact__card__icon__item"><span class="material-icons-outlined notranslate contact__card__icon">phone</span> ${phones.join(" / ")} </div>`;
	}
	if (model.contact) {
		if (model.contact.kontaktkort_tittel) {
			title = `<p>${model.contact.kontaktkort_tittel}</p>`;
		}
	} else if (model.title) {
		title = `<p>${model.title}</p>`;
	}
	if (model?.email) {
		if (model?.email?.startsWith("http")) {
			email = `
				<div class="xcol contact__card__icon__item">
					<span class="material-icons-outlined notranslate contact__card__icon">email</span>
					<a href="${model.email}" target="_blank">
					${language("CONTACT_CONTACT_LINK")}</a>
				</div>`;
		} else {
			email = `<div class="xcol contact__card__icon__item"><span class="material-icons-outlined notranslate contact__card__icon">email</span><a href="mailto:${model.email}" class="text-truncate">${model.email}</a></div>`;
		}
	}
	if (model.name) {
		name = `<span class="contact__card__name">${model.name}</span>`;
	}
	if (model.pos) {
		const mapguid = createGuid();
		address = `
            <p>
                ${language("CONTACT_VISITTADDRESS")}:<br/> 
                ${model.pos.adressetekst}, 
                ${model.pos.postnummer} ${model.pos.poststed}<br/>
                <a href="#map" class='contact__openmap' 
                    data-lat="${model.pos.lat}" 
                    data-lon="${model.pos.lon}" 
                    data-openmap="${mapguid}"
                    data-popuptext="${model.pos.adressetekst} ${model.pos.postnummer} ${model.pos.poststed}" >Se kart</a>
                <div class='contact__place__map' data-mapid="${mapguid}" ></div>
            </p>`;
	} else if (model.address) {
		if (model.address.kontaktkort_visitingaddress) {
			address = `<p class="contact__card__label">${language("CONTACT_VISITTADDRESS")}:</p>
      <p>${model.contact.kontaktkort_visitingaddress}</p>`;
		} else if (typeof model.address === "string") {
			address = `<p class="contact__card__label">${language("CONTACT_VISITTADDRESS")}:</p>
      <p>${model.address}</p>
      <a href="https://www.google.com/maps/?q=${model.address},${model.postaddress}&zoom=20" aria-label="${language("CONTACT_SEEMAP")} (${language("NAV_OPEN_I_NEW")})" target=_blank>${language("CONTACT_SEEMAP")}</a>`;
		}
	}
	if (model.postaddress) {
		address += `<p class="contact__card__label">${language("CONTACT_POSTADDRESS")}:</p>${model.postaddress}`;
	}
	if (model.about) {
		about = `<p clas="contact__card__about">${model.about}</p>`;
	}

	return `
            <div class="contact__card">
            
                ${name}
                ${title}
                ${phone}
                ${email}
                ${address}
                ${about}
                
            </div>
       `;
};

export const setContactArticle = (model) => {
	let phone = "";
	let email = "";
	let name = "";
	let title = "";
	let about = "";
	const imageguid = createGuid();
	let imagespace = "col-1";
	const phones = [];

	if (model.phone) {
		phones.push(`<a href="tel:${model.phone}">${model.phone}</a> `);
	}
	if (model.wiredPhone) {
		phones.push(`<a href="tel:${model.wiredPhone}">${model.wiredPhone}</a> `);
	}
	if (model.phone || model.wiredPhone) {
		phone = `<div class="contact__card__icon__item pr-md-4"><span class="material-icons-outlined notranslate contact__card__icon">phone</span> ${phones.join(" / ")} </div>`;
	}
	if (model.title && model.department) {
		const department = model.department ? `- ${model.department}` : "";
		title = `<p>${model.title} ${department}</p>`;
	} else if (model.department) {
		title = `<p>${language("CONTACT_DEPARTMENT")}: ${model.department}</p>`;
	} else if (model.title) {
		title = `<p>${model.title}</p>`;
	}
	if (model?.email) {
		if (model?.email?.startsWith("http")) {
			email = `
				<div class="contact__card__icon__item">
				<span class="material-icons-outlined notranslate contact__card__icon">email</span>
					<a href="${model.email}" target="_blank">
					${language("CONTACT_CONTACT_LINK")}</a>
				</div>`;
		} else {
			email = `<div class="contact__card__icon__item"><span class="material-icons-outlined notranslate contact__card__icon">email</span><a href="mailto:${model.email}" class="text-truncate">${model.email}</a></div>`;
		}
	}
	if (model.name) {
		name = `<span class="contact__card__name">${model.name}</span>`;
	}
	if (model.about) {
		about = `<p class="contact__card__about">${model.about}</p>`;
	}

	if (model.image) {
		getImageByContentId(model.image, (img) => {
			if (img.url.includes("preview.sdl.no")) {
				img.url = img.url.replace("https://preview.sdl.no", `${window.apiUrl.replace("/api", "")}/proxy/ntbpreview`);
			}
			const cloudinaryUrl = `https://res.cloudinary.com/ssp/image/fetch/g_auto,w_180,h_180,c_fill,f_auto/${img.url}`;

			$(`#image_${imageguid}`).html(`<img src="${cloudinaryUrl}" alt="Profilbile" />`);
		});

		imagespace = "contact__card__image";
	}

	return `
            <div class="contact__card contact__card--article">
                <div class="row ml-0 mr-0">
                    ${model.image ? `<div id="image_${imageguid}" class="${imagespace}"></div>` : ""}
                    <div>
                        ${name}
                        ${title} 
                    </div>
                </div>
                <div class="row contact__card__icon__row ml-0 mr-0">
                    ${phone}
                    ${email}
                </div>
                ${about}
            </div>
            <div class="col-1"></div>
            <!--/div>
            </div-->
       `;
};

export const setContactInfo = (data, wrapper = false) => {
	let cards = [];

	if (data[0].kontaktkort_personnavn.length < 1 && data[0].kontaktkort_tittel.length < 1) {
		return '';
	}

	$.each(data, (nr, contact) => {
		if (!contact.kontaktkort_personnavn) {
			contact.kontaktkort_personnavn = contact.kontaktkort_tittel;
			contact.kontaktkort_tittel = "";
		}

		const name = contact.kontaktkort_personnavn;
		const title = contact.kontaktkort_tittel;
		const phone = contact.kontaktkort_telefon;
		const email = contact.kontaktkort_epost;
		const address = contact.kontaktkort_visitingaddress;
		const postaddress = contact.kontaktkort_postadresse;
		const pos = contact.kontaktkort_posisjonsdata;

		cards.push(
			setContactRight({
				name,
				title,
				phone,
				email,
				address,
				postaddress,
				pos,
			}),
		);
	});

	cards = cards.join("");

	$("body").on("click", ".contact__openmap", function (e) {
		e.preventDefault();

		const openmap = $(this).data("openmap");

		mapSinglepoi(`.contact__place__map[data-mapid=${openmap}]`, {
			lat: $(this).data("lat"),
			lon: $(this).data("lon"),
			popuptext: $(this).data("popuptext"),
			zoom: 15,
		});
	});

	if (wrapper === true) {
		return `
				<div class="article" id="unit__contact">
						<div class="article__keyinfo">
								<h2>${language("CONTACT_CONTACT")}</h2>
								<div class="contact_cards text-truncate">
										${cards}
								</div>
						</div>
				</div>`;
	}
	return `
				<div class="article__keyinfo">
						<h2>${language("CONTACT_CONTACT")}</h2>
						<div class="contact_cards text-truncate">
								${cards}
						</div>
				</div>`;
};

export const ViewContactByAPI = (metaData, title = "", description = "", placement = "article") => {
	if (testDynData(metaData, "localId", "9c49f83a-bd49-425b-8fbb-6b211c038391")) {
		// Dynamisk mal kontaktkort.
		let mail = getDynDataOne(metaData, "9c49f83a-bd49-425b-8fbb-6b211c038391", "localId");
		const role = getDynDataOne(metaData, "4887e067-c9d5-4f35-b7a4-61222faf062b|9778c05a-d282-4cc2-8fed-30b2921dafde", "localId"); // .value; //
		const desc = getDynDataOne(metaData, "cd822d62-0221-4c43-b59d-0755a34df95c", "localId"); // .value;
		if (mail) {
			// has mail.
			mail = mail.value;
			getContactByEmail(mail, (_data) => {
				const data = _data[0];
				if (placement === "article") {
					const contact = setContactArticle({
						name: data.Name || false,
						email: data.Email || false,
						title,
						phone: data.Mobile || false,
						about: description,
						department: data.Subdivision || false,
					});

					$(".article__content").html(contact);
				} else if (placement === "right") {
					const contact = setContactRight({
						name: data.Name || false,
						email: data.Email || false,
						title: title || role.value || false,
						phone: data.Mobile || false,
						about: description || desc.value,
						department: data.Subdivision || false,
					});
					const html = `<div class="article__keyinfo">
                        <div class="contact--">
                           ${contact}
                        </div>
                    </div>`;

					$("#unit__relations").append(html);
				}
			});
		}
	}
};
